import { Equal }		from "ts-base/equal";
import { Monoid }		from "ts-base/monoid";
import { Group }		from "ts-base/group";
import { Comparator }	from "ts-base/comparator";

export namespace Numbers {
	export const roundTo	= (value:number, precision:number):number	=>
		Math.round(value / precision) * precision;

	export const intDigits	= (it:number, width:number):string =>
		(it < 0 ? "-" : "") + Math.abs(Math.round(it)).toString().padStart(width, "0");

	// returns a number between 0 (inclusive) and limit (exclusive)
	export const randomInt	= (limit:number):number	=> {
		if (limit < 0)	throw new TypeError(`limit has to be >= 0 but got ${limit}`);
		return Math.floor(Math.random() * limit);
	};

	export const equal:Equal<number>		= Equal.builtin;
	export const compare:Comparator<number>	= Comparator.builtin;

	export const sum:Group<number>	= {
		empty:			0,
		concat:			(a, b)	=> a + b,
		inverse:		(a)		=> -a,
		concatInverse:	(a, b)	=> a - b,
	};

	export const product:Group<number>	= {
		empty:			1,
		concat:			(a, b)	=> a * b,
		inverse:		(a)		=> 1 / a,
		concatInverse:	(a, b)	=> a / b,
	};

	export const min:Monoid<number>	= {
		empty:	Infinity,
		concat:	(a, b) => Math.min(a, b),
	};

	export const max:Monoid<number>	= {
		empty:	-Infinity,
		concat:	(a, b) => Math.max(a, b),
	};
}
